// AccountReferralSkeleton.jsx — mirrors the real referral layout
import React from "react";
import "../../account.css";
import "../accountReferral.css";
import "./accountReferralSkeleton.css";

const AccountReferralSkeleton = () => {
	return (
		<div className="ac-page">
			{/* HERO */}
			<div className="ac-hero apr-skel-hero">
				<div className="apr-skel-hero-icon" />
				<div className="apr-skel-hero-line w-70" />
				<div className="apr-skel-hero-line w-90" />
				<div className="apr-skel-hero-line w-50" />
			</div>

			{/* STATS */}
			<div className="ac-stats ac-stats--3">
				{Array.from({ length: 3 }).map((_, i) => (
					<div key={i} className="apr-skel-stat shimmer" />
				))}
			</div>

			{/* CODE + LINK / HOW IT WORKS */}
			<div className="apr-grid">
				<div className="ac-card">
					<div className="ac-card-head">
						<div className="apr-skel-icon shimmer" />
						<div className="apr-skel-line shimmer w-40" />
					</div>

					<div className="ac-card-body">
						<div className="apr-skel-box shimmer" />
						<div className="apr-skel-line shimmer w-30" />
						<div className="apr-skel-box shimmer" />
					</div>
				</div>

				<div className="ac-card">
					<div className="ac-card-head">
						<div className="apr-skel-icon shimmer" />
						<div className="apr-skel-line shimmer w-50" />
					</div>

					<div className="ac-card-body">
						<div className="apr-skel-line shimmer w-80" />
						<div className="apr-skel-line shimmer w-70" />
						<div className="apr-skel-line shimmer w-90" />
					</div>
				</div>
			</div>

			{/* HISTORY */}
			<div className="ac-card">
				<div className="ac-card-head">
					<div className="apr-skel-icon shimmer" />
					<div className="apr-skel-line shimmer w-50" />
				</div>

				<div className="ac-card-body is-flush">
					{Array.from({ length: 3 }).map((_, i) => (
						<div key={i} className="apr-skel-row">
							<div className="apr-skel-line shimmer w-50" />
							<div className="apr-skel-badge shimmer" />
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default AccountReferralSkeleton;
